import { render, staticRenderFns } from "./YourProfileView.vue?vue&type=template&id=23cf7f08&scoped=true"
import script from "./YourProfileView.vue?vue&type=script&lang=js"
export * from "./YourProfileView.vue?vue&type=script&lang=js"
import style0 from "./YourProfileView.vue?vue&type=style&index=0&id=23cf7f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cf7f08",
  null
  
)

export default component.exports